<template>
<div>
  <CCol sm="6" md="2">
    <CButton block color="primary" @click="generatePDF" style="margin: 0px auto 10px;">Print</CButton>
  </CCol>
<CCard>
<full-calendar :config="config" :events="events"   />
</CCard>

</div>

</template>

<script>
import { FullCalendar } from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import moment from 'moment'
import firebase from "firebase";
import { jsPDF,jsPDFOptions} from "jspdf";
import 'jspdf-autotable';



export default {
  components: {
    FullCalendar,
    jsPDF
  },
  data() {
    return {
       myModal:false,
      heading : "My Appointments",
      events: [],
     
       colors: ['blue', 'indigo', 'info', 'secondary', 'green', 'orange', 'primary'],
      config: {
        selectable: true,
       defaultView: 'agendaWeek',
        eventClick: this.handleEventClick,
        dateClick:this.handleDateClick,
        eventRender: function(event, element) {
        },
          

      },
      toPdf : []
    };
  },
  methods:{
  handleEventClick: function (arg) {
    //this.myModal=true;
    console.log('envents',arg)
     confirm('Event' + arg.title)
    },
    handleDateClick: function (arg) {
       alert('Event' + arg.title)
    },  
    getAppointments(){
      this.events = [];
      const db = firebase.firestore();
      db.collection("Appointment")
        .where("SID", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
		  let timestamp = doc.data().start
		  let myDate = new Date(timestamp.seconds * 1000)
        
            var start = myDate
            var end = moment(start).add(30, 'm')
            console.log(this.colors[this.rnd(0, this.colors.length - 1)])
            // console.log("End",end)
            let temp = {
					    title: doc.data().doctor,
					    start: start,
              end: end,
              id : doc.data().bookingNumber,
               color: this.colors[this.rnd(0, this.colors.length - 1)],
                 textColor: 'black'
            };
            let temp1 = {
					    title: doc.data().bookingNumber,
					    start: start.toString(),
              end: end.toString(),
              
            };
            this.events.push(temp)
            this.toPdf.push(temp1)
          })
          console.log(this.events)
        })
    },
     rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
        print(Math.floor((b - a + 1) * Math.random()) + a)
      },
    generatePDF() {
      const columns = [
        { title: "Title", dataKey: "title" },
        { title: "Start", dataKey: "start" },
        { title: "End", dataKey: "end" }
      ];
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: "letter"
      });
      // text is placed using x, y coordinates
      doc.setFontSize(16).text(this.heading, 0.5, 1.0);
      // create a line under heading 
      doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
      // Using autoTable plugin
      doc.autoTable({
        columns,
        body: this.toPdf,
        margin: { left: 0.5, top: 1.25 }
      });
      // Using array of sentences
      // doc
      //   .setFont("helvetica")
      //   .setFontSize(12)
      //   .text(this.moreText, 0.5, 3.5, { align: "left", maxWidth: "7.5" });
      
      // Creating footer and saving file
      doc
        .setFont("times")
        .setFontSize(11)
        .setTextColor(0, 0, 255)
        .text(
          "This is a simple footer located .5 inches from page bottom",
          0.5,
          doc.internal.pageSize.height - 0.5
        )
        .save(`${this.heading}.pdf`);
    },
  },
  mounted(){
    this.getAppointments()
  },
  created: function(){
    
  }
};
</script>

<style>
 .fc-day-grid-event .fc-time {
  font-weight: 300;
    color: white;
}
 .fc-day-grid-event .fc-title {

    color: white;
}
 .fc-time-grid-event.fc-short .fc-time:before {
    content: attr(data-start);
    color: white;
}
.fc-time-grid-event.fc-short .fc-title {
    font-size: .85em;
    padding: 0;
    color:white ;}
    
</style>
